import { EnvironmentModel } from '@core/models';

const serverUrl = 'https://raven.bitvarklab.com/api';
const demoDatasetId = '64df41ff554f61b8743a1483';

export const environment: EnvironmentModel = {
  production: true,
  locale: 'it-IT',
  envCode: 'dev',
  accountCode: 'NEX',
  appCode: 'rca',
  flowCode: 'operation',
  baseUrl: `${serverUrl}/public/64c7be226cff71fd021943db/nex-self-digital`,
  apiBaseUrl: `${serverUrl}/public/64c7be226cff71fd021943db/nex-self-digital`,
  securityBaseUrl: `${serverUrl}/public/64c7be226cff71fd021943db/nex-self-digital`,
  devMode: false,
  demoDatasetId
};
